import { Row } from "@components/Layout";
import { styled } from "solid-styled-components";

export const PlayProgressWrapper = styled(Row)`
  border-radius: 3px;
  background: ${({ theme }) => theme?.colors.accentTertiary}50;
`;

export const PlayProgressBar = styled.div`
  height: 100%;
  background: ${({ theme }) => theme?.colors.accentPrimary};
  border-radius: 3px;
`;
